define('../app/fukit/configuration/app.kit.controller.service.configuration',['require','exports','module','backbone.radio'],function(require, exports, module) {
  var Radio = require('backbone.radio');

  var AppKitControllerServiceConfiguration = {
    radioRequests: {
      'AppKit.controllerServiceConfiguration options': 'options',
    },

    options: function() {
      return {
        region: Radio.channel('layoutConfiguration')
          .request('layout')
          .getRegion('content'),
      };
    },
  };
  module.exports = AppKitControllerServiceConfiguration;
});

